import React, {PureComponent, CSSProperties} from 'react'
import {inject} from 'mobx-react'
import cxs from 'cxs/component'
import Store from 'Store'
import Theme, {mediaQueries} from 'Theme'
import {t} from 'helpers/i18n'
import History from 'helpers/History'
import {sections} from 'scenes/Main'
import {Button, Icon} from 'elements'
import HamburgerMenu from './HamburgerMenu'
import CheeseburgerMenu from './CheeseBurgerMenu'
import theme from 'Theme'

interface Props {
  store?: Store
  style: any
}

interface State {
  selectedSection?: {
    name: string
    links: {
      name: string
      path: string
    }[]
  }
  activePath?: string
  open: boolean
}

@inject('store')
class NavBarMobile extends PureComponent<Props, State> {
  state: State = {
    selectedSection: undefined,
    activePath: undefined,
    open: false
  }

  constructor(props, context) {
    super(props, context)
    const currentPath = (pathRegex.exec(History.location.pathname) || [])[1]
    const selectedSection = currentPath
      ? sections(props.store!.users.user).find(
        section =>
          section.links.find(link => link.path.indexOf(currentPath) > -1)
            ? true
            : false
      )
      : undefined
    this.state.selectedSection = selectedSection
    this.state.activePath = currentPath
  }

  items = []

  handleSection = (selectedSection?) => () => {
    this.setState({selectedSection})
    if (selectedSection) this.handleLink(selectedSection.links[0].path)()
  }

  handleLink = activePath => () => {
    this.setState({activePath})
    History.push(activePath)
  }

  handleHamburgerClick = (event) => {
    this.setState({
      open: !this.state.open
    })
  }

  closeMenu = () => {
    this.setState({open: false})
  }

  render() {
    const {selectedSection} = this.state
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        height: Theme.size.bar,
        borderTop: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
        backgroundColor: Theme.color.background
      }}>
        {/*{selectedSection ? (
          <Button onClick={this.handleSection()}>
            <Icon name="back" />
          </Button>
        ) : null}
        {!selectedSection
          ? sections(this.props.store!.users.user).map(section => (
            <StyledButton
              key={section.name}
              onClick={this.handleSection(section)}>
              {t(section.name)}
            </StyledButton>
          ))
          : selectedSection.links.map(link => (
            <StyledButton
              key={link.name}
              primary={isActive(link.path)}
              onClick={this.handleLink(link.path)}>
              {t(link.name)}
            </StyledButton>
          ))}*/}
        <HamburgerMenu
          isOpen={this.state.open}
          menuClicked={this.handleHamburgerClick}
        />
        <CheeseburgerMenu
          noShadow={true}
          topOffset={theme.size.bar}
          isOpen={this.state.open} closeCallback={this.closeMenu}>
          {/*<div className="menu">
            {this.items.map(i => <div className="menu-item" key={i}>
              <a
                href="#"
                onClick={this.closeMenu}
              >
                Menu item {i}
              </a>
            </div>)}
            <p className="hint">Click outside the menu to close it, or swipe it closed on touch device</p>

          </div>*/}
          <div
            style={{
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            {sections(this.props.store!.users.user).map(section => (
              <DropDown key={section.name}>
                <StyledButton
                  onClick={() => {
                  }}
                >
                  {t(section.name)}
                </StyledButton>
                <DropDownContent>
                  {section.links.map(link => (
                    <DropDownLink
                      onClick={this.handleLink(link.path)}
                      key={link.name}>
                      {t(link.name)}
                    </DropDownLink>
                  ))}
                </DropDownContent>
              </DropDown>
            ))}
          </div>
        </CheeseburgerMenu>
      </div>
    )
  }
}

const DropDown = cxs('div')({
  float: 'left',
  overflow: 'hidden',
  ':hover div': {
    display: 'block'
  },
  ':hover > button': {
    color: Theme.color.primary
  },
  borderBottom: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
} as CSSProperties)

const StyledButton = cxs(Button)({
} as CSSProperties)

const DropDownContent = cxs('div')({
  zIndex: 1002,
  display: 'none',
  position: 'relative',
  backgroundColor: Theme.color.background,
  border: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
  /*borderTopWidth: 0,*/
  ':last-child': {
    borderWidth: 0
  },
  /*boxShadow: '0px 3px 5px -1px rgba(0,0,0,0.2)'*/
} as CSSProperties)

const DropDownLink = cxs(Button)({
  display: 'block',
  width: '100%',
  float: 'none',
  borderBottom: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
  ':last-child': {
    borderWidth: 0
  },
  ':hover': {
    color: Theme.color.primary
  }
} as CSSProperties)

const Wrapper = cxs('div')({
  display: 'flex',
  height: Theme.size.bar,
  borderTop: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
  backgroundColor: Theme.color.background
} as CSSProperties)

/*const StyledButton = cxs(Button)({
  flex: 1
} as CSSProperties)*/

const pathRegex = /\/(\w*)/
// const pathRegex = /\/.*?\/(\w*)/

const isActive = (_path: string) => {
  const currentPath = (pathRegex.exec(History.location.pathname) || [])[1]
  const path = (pathRegex.exec(_path) || [])[1]
  return currentPath === path
}

export default NavBarMobile



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/NavBarMobile/index.tsx